import React, { useEffect, useMemo, useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import { useDebounce } from "use-debounce";
import {
  fetchPromptTemplates,
  fetchVanillaprompt,
  fetchprompts,
  getPromptPreview,
  promptsSelector,
  setRunPromptId,
  triggerDeletePrompt,
} from "../../../../store/slices/prompts";
import { useDispatch, useSelector } from "react-redux";
import _, { replace } from "lodash";
import {
  fetchSimilarReviews,
  reviewsSelector,
  triggerExecutePromptMultiple,
} from "../../../../store/slices/reviews";
import { logSelector } from '../../../../store/slices/logs'
import { encode } from "gpt-tokenizer";
import {
  getTopicsData,
  topicsSelector,
  getStandardTopicsData,
} from "../../../../store/slices/topics";
import { companiesSelector } from "../../../../store/slices/company";
import CustomPrompt from "./customPrompt";
import { convertArrayToDictionary, defaultGuid, getDefailtGpt5xVal, getSalutationSettings, normalizeReasoningEffort } from "../../../../common/utils";
import { locationsSelector } from "../../../../store/slices/location";
import { phrases } from "../../../../common/phrases";
import { isValidJSON } from "./reviewUtils";
import { use } from "react";

const getPhrases = (data) => {
  const finalObj = { withText: [], withoutText: {} };
  finalObj.withText = getPhraseArr(data, 'WithText')
  finalObj.withoutText = getPhraseArr(data, 'WithoutText')
  return finalObj;
}
const getPhraseArr = (data, key) => {
  // const keyValues = ['ReviewsWithoutTextNegative','ReviewsWithoutTextNegative']
  const keyValues = [('Reviews' + key + 'Negative'), 'Reviews' + key + 'Positive']
  const tempArr = _.orderBy(_.filter(_.clone(data), it => { return it?.status === 1 && _.includes(keyValues, it?.key) }), 'phrase')
  const grouped = _.groupBy(tempArr, 'phrase')
  const finalArr = []
  _.map(grouped, (value, key) => {
    let ratings = {
      1: _.map(_.filter(value, it => _.includes(it?.ratings, '1')), 'text'),
      2: _.map(_.filter(value, it => _.includes(it?.ratings, '2')), 'text'),
      3: _.map(_.filter(value, it => _.includes(it?.ratings, '3')), 'text'),
      4: _.map(_.filter(value, it => _.includes(it?.ratings, '4')), 'text'),
      5: _.map(_.filter(value, it => _.includes(it?.ratings, '5')), 'text'),
    }
    const negative = _.filter(value, it => it?.ratings === "1,2,3")
    const positive = _.filter(value, it => it?.ratings === "4,5")
    // finalArr.push({ positive: _.map(positive, 'text'), negative: _.map(negative, 'text') })
    finalArr.push(ratings)
  })
  return finalArr
}
function getPhrasesString(phrasesStringValue) {
  let latestString = ''
  if (JSON.parse(phrasesStringValue)) {
    const tt = JSON.parse(phrasesStringValue)
    if (tt) {
      _.map(tt, (a, i) => {
        if (i === 0 || i === _.size(tt) - 1) {
          return latestString += (i === 0 && _.size(tt) !== 1) ? `['${a}',` : _.size(tt) === 1 ? `['${a}']` : `'${a}']`
        }
        else {
          return latestString += `${a},`
        }
      })
    }

  }
  return latestString.replace(/\\"/g, '"');
}
export function handlePromptPreview(selectedCompany) {
  const localStorageData = getSalutationSettings(selectedCompany)
  let input = {}
  if (!_.isEmpty(localStorageData)) {

    const closing = localStorageData?.Closing
    if (_.trim(closing?.text) && !_.isEmpty(_.trim(closing?.text))) {
      input['Closing'] = _.trim(closing?.text) ?? ''
    }
    input['ClosingPlacement'] = closing?.paragraph ? 'SeparateParagraph' : 'Other'
    const greeting = localStorageData?.Greeting
    if (_.trim(greeting?.text) && !_.isEmpty(_.trim(greeting?.text))) {
      const additionalText = greeting.additionalText ?? ""
      input['Greeting'] = greeting?.text === '[Name Only]' ? _.trim(additionalText) : _.trim((greeting?.text ?? "") + " " + additionalText)
    }
    input['GreetingPlacement'] = greeting?.default ? 'NameOnly' : greeting?.paragraph ? 'SeparateParagraph' : 'Other'
    const businessName = localStorageData?.BusinessName
    if (_.trim(businessName?.text) && !_.isEmpty(_.trim(businessName?.text))) {
      input['BusinessName'] = _.trim(businessName?.text) ?? ""
    }
    const contactPhrase = localStorageData?.ContactPhrase
    if (_.trim(contactPhrase?.text)) {
      input['ContactPhrase'] = _.trim(contactPhrase?.text) ?? ''
    }
    const contactInfo = localStorageData?.ContactInfo
    if (_.trim(contactInfo?.text)) {
      input['ContactInfo'] = _.trim(contactInfo?.text) ?? ''
    }
  }
  return input
}
const CustomizeResponse = ({
  selectedCompany,
  selectededReview,
  selectedReviewText,
  selectedReviewer,
  selectedReviewIds,
  setRefresh,
  refresh,
  gptUsage,
  selectedId,
  setSelectedId,
  setCache,
  selectedExampleReviews,
  cache,
  text,
  indexObj,
  setText,
  selectedFacts, selectedThen, setSelectedThen,
  customSettings,
  setCustomsettings,
  vanillaCache,
  setVanillaCache,
  sentimentCache,
  setSentimentCache,
  setPromptOutput,
  selectedBrandVoiceContainer,
  buttonText = 'Submit',
  isReviews,
  isPrompt,
  setIsMultiple,
  isMultiple,
  setSelectedReviewIds,
  setSelectedReviewText,
  setTopicType,
  topicType,
  isSentiment = false, boxHeight,
  chatData = false,
  onPromptChange,
  onPromptSettingsChange,
  onPromptsInputChange,
  chatId,
  setPromptTab
}) => {
  const { reviews } = useSelector(reviewsSelector)
  const [isHovered, setIsHovered] = useState(false);
  const [isHovered2, setIsHovered2] = useState(false);
  const [promptName, setPromptName] = useState("");
  const [promptType, setPromptType] = useState("");
  const [promptId, setPromptId] = useState(null);
  const [reviewSelectionType, setReviewSelectionType] = useState("");
  const [selectedTab, setSelectedTab] = useState(0);
  const [llm, setLlm] = useState("gpt-4");
  const [cached, setCached] = useState(false);
  const [verbosity, setVerbosity] = useState("medium");
  const [reasoning_effort, setReasoningEffort] = useState("medium");
  const [serviceTier, setServiceTier] = useState(null);
  const [temperature, setTemperature] = useState(0);
  const [seed, setSeed] = useState("None");
  const [inputFactor, setInputFactor] = useState(40);
  const [jsonResponse, setJsonResponse] = useState(false);
  const [jsonResponseSchema, setJsonResponseSchema] = useState(false);
  const [responseApi, setResponseApi] = useState(false);
  const [api, setApi] = useState("completions");
  const [nextPromptId, setNextPromptId] = useState(null);
  const [maxLength, setMaxLength] = useState(0);
  const [topP, setTopP] = useState(1);
  const [presencePenalty, setPresencePenalty] = useState(0);
  const [frequencyPenalty, setFrequencyPenalty] = useState(0);
  const [jsonResponseSchemaValue, setJsonResponseSchemaValue] = useState("");
  const [web_search, setWeb_search] = useState(false);
  const [promptsInput, setPromptsInput] = useState({})
  const [prompt, setPrompt] = useState("");
  const [systemPrompt, setSystemPrompt] = useState("");
  const [selectedPromt, setSelectedPromt] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedToneValue, setSelectedToneValue] = useState("Professional");
  const [selectedLengthValue, setSelectedLengthValue] = useState(50);
  const [open, setOpen] = useState(false);
  const [openWarning, setWarning] = useState(false);
  const [topicNames, setTopicNames] = useState(null);
  const [topicNames1, setTopicNames1] = useState(null);
  const [selectedStyle, setSelectedStyle] = useState("");
  const [promptTemplateType, setPromptTemplateType] = useState("");
  const { promptTemplates } = useSelector(locationsSelector);
  const { prompts } = useSelector(locationsSelector)
  const { companies } = useSelector(companiesSelector);
  const [tabValue, setTabValue] = useState(0);
  const { subTopics, responsePhrases, locations, facts } = useSelector(locationsSelector)
  const { promptPreview, runPromptId } = useSelector(promptsSelector)
  const { executePromptMultiple, similarReviews, loadingReviews, generateResponse } =
    useSelector(reviewsSelector);
  const { apiKey } =
    useSelector(logSelector);
  const locationDic = React.useMemo(() => convertArrayToDictionary(locations, 'locationId'), [locations])
  const [openDrawer, setOpenDrawer] = useState(false);
  const [requestId, setRequestId] = useState(false);
  const { companyTopics, standardTopics } = useSelector(topicsSelector);
  const { loadingCompany } = useSelector(companiesSelector);
  const [isTopPChecked, setIsTopPChecked] = useState(true);
  const [isTemperatureChecked, setIsTemperatureChecked] = useState(true);
  

  const dispatch = useDispatch();

  const bindPromptTemplates = () => {
    const commaSepated = _.filter(promptTemplates, {
      value: "Comma Separated Topics",
    });
    const other = _.filter(promptTemplates, (it) => {
      return it.value !== "Comma Separated Topics";
    });
    return _.concat(commaSepated, other);
  };
  const bindTopicWithCategory = (data) => {
    const parents = convertArrayToDictionary(_.filter(data, {
      parentTopicId: null,
    }), 'topicId');
    const topic = _.filter(data, it => {
      return it.parentTopicId
    });
    const otherDetails = _.reduce(parents, function (result, value, key) {
      result[value.name + ' General'] = value.name;
      return result;
    }, {});
    const topicDetails = _.reduce(topic, function (result, value, key) {
      result[value.name] = parents[value.parentTopicId]?.name
      return result;
    }, {})
    return { ...topicDetails, ...otherDetails };
  };
  const promptTemplateData = React.useMemo(
    () => bindPromptTemplates(),
    [promptTemplates]
  );
  const companyData = React.useMemo(
    () => _.find(companies, { companyId: selectedCompany }),
    [companies, selectedCompany]
  );
  const topicData = React.useMemo(
    () =>
      topicType == 1 ? _.cloneDeep(companyTopics) : _.cloneDeep(standardTopics),
    [topicType, companyTopics, standardTopics]
  );
  const topicWithCategory = React.useMemo(() => bindTopicWithCategory(topicData) ?? {}, [topicData])
  const promptOutPut = React.useMemo(() => executePromptMultiple?.[promptId] ?? [], [executePromptMultiple, promptId])
  const selectedReviewDic = React.useMemo(() => {
    const reviewArray = Array.isArray(selectededReview) ? selectededReview : selectededReview ? [selectededReview] : [];
    const filteredReviews = reviewArray.filter(item => item && item.reviewId);
    return convertArrayToDictionary(filteredReviews, 'reviewId');
  }, [selectededReview])
  
  const topicDetails = useMemo(
    () => !loadingReviews ? convertArrayToDictionary(similarReviews?.sentiments, "sentiment") : [],
    [similarReviews?.sentiments, loadingReviews]
  );
  useEffect(() => {
    if (promptTemplateData) {
      setSelectedStyle(promptTemplateData[0]?.value);
    }
  }, [promptTemplateData]);

  const newFactsData = useMemo(() => {
    const reviewLocation = locationDic?.[selectededReview?.[0]?.locationId];

    const multipleBrands = reviewLocation?.brandId
      ? _.unionBy(_.filter(locations, { brandId: reviewLocation.brandId }), 'locationId')
      : [];

    const multipleRegions = reviewLocation?.regionId
      ? _.unionBy(_.filter(locations, { regionId: reviewLocation.regionId }), 'locationId')
      : [];

    return selectedReviewIds?.length > 0
      ? _.filter(
        _.map(_.cloneDeep(facts), (item) => {
          const isLocation = _.toLower(item.entityType) === 'location';
          const isRegion = _.toLower(item.entityType) === 'region';
          const isBrand = _.toLower(item.entityType) === 'brand';

          if (
            reviewLocation &&
            (
              (item?.entityIds?.length > 0 && isLocation && _.includes(item.entityIds, reviewLocation.locationId)) ||
              (item?.entityIds?.length > 0 && isRegion && _.includes(item.entityIds, reviewLocation.regionId)) ||
              (item?.entityIds?.length > 0 && isBrand && _.includes(item.entityIds, reviewLocation.brandId))
            )
          ) {
            const isMany =
              (isLocation && item.entityIds.length > 1) ||
              (isRegion && multipleRegions?.length > 1) ||
              (isBrand && multipleBrands?.length > 1);

            return {
              ...item,
              locationName: isMany ? 'Multiple Locations' : reviewLocation?.name,
            };
          }

          return !item?.entityIds?.length ? item : null;
        }),
        Boolean
      )
      : [];
  }, [facts, locationDic, locations, selectededReview, selectedReviewIds]);

  const firstSelectedFact = useMemo(() => {
    const selectedFactIds = new Set((selectedFacts ?? []).map(f => f.factId));

    return newFactsData.filter(fact => (selectedFactIds?? []).has(fact.factId));
  }, [selectedFacts, newFactsData]);

  useEffect(() => {
    if(!loadingCompany && selectedReviewIds?.[0]){

      dispatch(fetchSimilarReviews(selectedReviewIds?.[0]));
    }
    
  }, [selectedReviewIds, loadingCompany])


  const factArr = useMemo(() =>
    customSettings?.facts
      ? _.size(selectedFacts) > 0
        ? _.map(selectedFacts, (it) => it?.fact)
        // : _.size(newFactsData) > 0
        //   ? _.map(newFactsData, (it) => it?.fact)
        : []
      : [][selectedFacts, customSettings]);


  // const formattedData = React.useMemo(() => {
  //   const nestedTopics = _.groupBy(companyTopics, "parentTopicId");

  //   const formattedData = {};

  //   _.forEach(_.orderBy(nestedTopics[null], "sequence"), (parentTopic) => {
  //     const parentName = parentTopic.name;
  //     formattedData[parentName] = _.map(
  //       _.orderBy(nestedTopics[parentTopic.topicId], "sequence"),
  //       "name"
  //     );
  //   });

  //   return formattedData;
  // }, [companyTopics]);


  const formattedData = React.useMemo(() => {
    const nestedTopics = _.groupBy(topicData, "parentTopicId");

    const formattedData = {};

    _.forEach(_.orderBy(nestedTopics[null], "sequence"), (parentTopic) => {
      const parentName = parentTopic.name;
      const childTopicsWithDescription = _.map(
        _.orderBy(nestedTopics[parentTopic.topicId], "sequence"),
        (childTopic) => `${childTopic.name}-${childTopic.description}`
      );
      formattedData[parentName] = childTopicsWithDescription;
    });

    return formattedData;
  }, [topicData]);
  const checkNullValues = (feedbackData) => {
    const areAllSubcategoriesNull = Object.keys(feedbackData).every(category => {
      return feedbackData[category].every(subcategory => subcategory.includes('null'));
    })
    return areAllSubcategoriesNull
  }
  const checkforNullDescription = useMemo(() => checkNullValues(formattedData), [formattedData])
  useEffect(() => {
    const findTemplateData = (value) => {

      return _.find(promptTemplateData, { value: value });
    }

    let data, topicNames, topicNames1;

    switch (selectedStyle) {
      case "Comma Separated Topics":
        data = findTemplateData("Comma Separated Topics");
        topicNames = `${data?.promptText}\n\n${topicData
          ?.map((topic) => topic?.name?.split("-")[0])
          ?.join(", ")}`;
        topicNames1 = `${topicData
          ?.map((topic) => topic?.name?.split("-")[0])
          ?.join(", ")}`
        break;

      case "Category And Topics":
        data = findTemplateData("Category And Topics");
        const result = _.map(formattedData, (value, key) => {
          return `${key}: ${value
            ?.map((childTopic) => childTopic?.split("-")[0])
            ?.join(", ")}`;
        });
        topicNames = `${data?.promptText}\n\n${_.join(result, "\n")}`;
        topicNames1 = `${_.join(result, "\n")}`;
        break;
      case "Category And Topics Array":
        data = findTemplateData('Category And Topics Array');
        if (Object.keys(formattedData)?.length > 0) {
          let res = [];
          const result = _.map(formattedData, (value, key) => {
            res = _.concat(res, _.map(value, it => {
              return it?.split("-")[0]
            }))
          });
          topicNames = `${data?.promptText}\n\n[\n${_.join(res, ",")}\n]`;
          topicNames1 = `[\n${_.join(res, ",")}\n]`;
        }
        break;
      case "Context Topics":
        data = findTemplateData("Context Topics");

        const resultContext = _.map(formattedData, (value, key) => {
          return `${key}\n ${value
            ?.map((childTopic) => {
              const splitTopic = childTopic.split("-");
              const topic = splitTopic[0];
              const description =
                splitTopic[1] === "null" ? "No description" : splitTopic[1];
              return `${topic}: ${description}`;
            })
            ?.join("\n ")}\n`;
        });
        topicNames = `${data?.promptText}\n\n${_.join(resultContext, "\n")}`;
        topicNames1 = `${_.join(resultContext, "\n")}`;
        break;
      case "Category And Topics With Description Array":

        data = findTemplateData("Category And Topics With Description Array");

        const result1Context = _.map(formattedData, (value, key) => {
          return `${key}\n ${value
            ?.map((childTopic) => {
              const splitTopic = childTopic.split("-");
              const topic = splitTopic[0];
              const description =
                splitTopic[1] === "null" ? "No description" : splitTopic[1];
              return `${topic}: ${description}`;
            })
            ?.join("\n ")}\n`;
        });
        topicNames = `${data?.promptText}\n\n${_.join(result1Context, "\n")}`;
        topicNames1 = `${_.join(result1Context, "\n")}`;
        break;
      default:
        // ???
        break;
    }

    if (data) {
      setTopicNames(topicNames);
      setTopicNames1(topicNames1)
      setPromptTemplateType(data.sectionType);
    }
  }, [selectedStyle, topicData]);
  const handlePromptInput = (key, val) => {
    setPromptsInput(prev => ({ ...prev, [key]: val }))
  }
  let c = React.useMemo(() => {
    handlePromptInput('Tone', selectedToneValue)
    const combinedPrompt = (systemPrompt ? systemPrompt : "" )+ "\n\n" + (prompt ? prompt : "");
    return {
            promptC:_.trim(prompt?prompt:'').replace(/\%Tone\%/g, `${selectedToneValue}`),
            systemPromptC: _.trim(systemPrompt?systemPrompt:'').replace(/\%Tone\%/g, `${selectedToneValue}`),
            }
  }, [prompt, selectedToneValue, systemPrompt]);
  let d = useMemo(() => {
    handlePromptInput(`${promptTemplateType}`, topicNames)
    return {
            promptD:c.promptC.replace(new RegExp(`%${promptTemplateType}%`, "g"), topicNames),
            systemPromptD: c.systemPromptC.replace(new RegExp(`%${promptTemplateType}%`, "g"), topicNames)
          }
  }, [topicNames, promptTemplateType, c]);
  let d1 = useMemo(() => {
    handlePromptInput('CommaSeparatedTopics', topicNames1)
    return {
            promptD1: d.promptD.replace(new RegExp(`%${'CommaSeparatedTopics'}%`, "g"), topicNames1),
            systemPromptD1: d.systemPromptD.replace(new RegExp(`%${'CommaSeparatedTopics'}%`, "g"), topicNames1)
          }
  }, [d])
  let k = useMemo(() => {
    handlePromptInput('WordLength', _.toString(selectedLengthValue))
    return {
            promptK: d1.promptD1.replace(/\%WordLength\%/g, `${selectedLengthValue} words`),
            systemPromptK: d1.systemPromptD1.replace(/\%WordLength\%/g, `${selectedLengthValue} words`)
          }
  }, [selectedLengthValue, d1])
  const factsString = useMemo(() => _.filter(factArr, a => a)
    .map((element, index) => `Fact ${index + 1}: ${element}`)
    .join("\n\n"), [factArr]);
  const [modifiedK, setModifiedK] = useState(k.promptK);
  const [previewK, setPreviewK] = useState(k.promptK);
  const [promptK, setPromptK] = useState(k.promptK);
  const [finalK, setFinalK] = useState(k.promptK);
  const [systemPromptPreviewK, setSystemPromptPreviewK] = useState(k.systemPromptK);

  useEffect(() => {
    setPromptK(k.promptK)
    setSystemPromptPreviewK(k.systemPromptK)
  }, [k])

  const getTokenCount = (text) => {
    const tokens = encode(text);
    return tokens?.length;
  };
  const [tokens] = useDebounce(getTokenCount(previewK), 1000, {
    leading: true,
  });
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const promptsInputObj = useMemo(() => {
    if (_.size(selectedReviewIds) > 0 && !loadingReviews) {
      const exampleArr =
        _.size(selectedExampleReviews) > 0
          ? selectedExampleReviews
          : _.orderBy(
            _.filter(similarReviews?.exampleReviews, (it) => it.responseText),
            "similarity",
            "desc"
          ).slice(0, 5);
      if (exampleArr) {
        const obj = {};
        const stringReviews = _.map(
          exampleArr,
          (it, i) =>
            `Review ${i + 1}: ${it.reviewText}${it.responseText ? "\n\nResponse: " + it.responseText : ""
            }`
        );
        const exampleResponseArr = _.map(
          exampleArr,
          (it, i) =>
            `${it.responseText ? "" + it.responseText : ""
            }`
        );
        const examplesArr = _.map(
          exampleArr,
          (it, i) => { return { Review: it.reviewText ?? "", Response: (it.responseText ? it.responseText : "") } }
        );
        const exampleResponseWithReviwerNameArr = _.map(
          exampleArr,
          (it, i) => { return { ReviewerName: it.author ?? "Custom Training Review", Response: it.responseText ?? "" } }
        );
        obj["Examples"] = customSettings?.training
          ? JSON.stringify(stringReviews.join(" \n\n "))
          : "";
        obj["ExamplesArr"] = customSettings?.training
          ? JSON.stringify(examplesArr)
          : "";
        obj["ExampleResponseArr"] = customSettings?.training
          ? JSON.stringify(exampleResponseArr)
          : "";
        obj["ExampleWithReviwerNameArr"] = customSettings?.training
          ? JSON.stringify(exampleResponseWithReviwerNameArr)
          : "";
        return obj;
      } else return null;

    }
    else { return null; }

  }, [selectedExampleReviews, selectedReviewIds, similarReviews?.exampleReviews, customSettings]);

  const filterResponsePrompt = (data) => {
    if (tabValue === 1) {
      return _.chain(data)
        .cloneDeep()
        // .filter(
        //   (it) => (it.type === 'Agent' || it.type === "Response") &&
        //     /vanilla/i.test(it.name)
        // )
        .sortBy("name")
        .value();
    }

    if (isSentiment) {
      return _.chain(data)
        .cloneDeep()
        .filter(
          (it) => (it.type === 'Agent' || it.type === "Sentiments")
        )
        .sortBy("type")
        .value();
    } else if (isPrompt) {
      return _.chain(data)
        .cloneDeep()

        .sortBy("type")
        .value();
    } else if (isReviews) {
      return _.chain(data)
        .cloneDeep()
        .filter(
          (it) =>
            (it.type === 'Agent' || it.type === "Response") &&
            it.reviewSelectionType !== "Multiple" &&

            !/vanilla/i.test(it.name)
        )
        .sortBy("type")
        .value();
    }
  };

  const responsePrompts = React.useMemo(() => {
    if (tabValue === 1) {
      return _.sortBy(prompts, 'name');
    }
    return _.sortBy(prompts, 'type')

  }, [prompts, tabValue]);
  const promptsDic = React.useMemo(() => {
    return convertArrayToDictionary(prompts, 'promptId');
  }, [prompts]);

  const toggleDrawer = (isOpen) => {
    setOpenDrawer(isOpen);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpenWarning = (id) => {
    setWarning(true);
    setSelectedPromt(id);
  };

  const handleCloseWarning = () => {
    setWarning(false);
  };

  const handleDelete = () => {
    dispatch(triggerDeletePrompt(selectedPromt));
    setTimeout(() => {
      dispatch(fetchprompts(selectedCompany));
    }, 1000);
    setWarning(false);
  };

  // useEffect(() => {
  //   if (selectedCompany) {
  //     dispatch(fetchprompts(selectedCompany));
  //   }
  // }, [selectedCompany]);

  const handleCopyClick = (isPreview, copyType) => {
    
    if (isPreview) {
      navigator.clipboard.writeText(previewK);
    }else if(copyType === 'systemPrompt'){
      navigator.clipboard.writeText(systemPrompt);
    }else if(copyType === 'userPrompt'){
      navigator.clipboard.writeText(prompt);
    }else if(copyType === 'preview'){
      navigator.clipboard.writeText(previewK);
    } else {
      navigator.clipboard.writeText(prompt);
    }
  };

  const handleStyleClick = (style) => {
    setSelectedStyle(style);
  };

  const handleOutputCopyClick = () => {
    navigator.clipboard.writeText(cache[selectedReviewIds]);
  };
  const getPromptSelectName = (prompt) => {
    return prompt?.name
  }
  useEffect(() => {

    if (responsePrompts?.length > 0) {
      if (isReviews) {
        const local = JSON.parse(localStorage.getItem('reviewPrompt'))
        const companyCheck = _.find(responsePrompts, a => a.promptId === local?.promptId)
        setPromptName(getPromptSelectName(companyCheck ? JSON.parse(localStorage.getItem('reviewPrompt')) ?? responsePrompts[0] : responsePrompts[0]))
        setPromptId(companyCheck ? JSON.parse(localStorage.getItem('reviewPrompt'))?.promptId ?? responsePrompts[0].promptId : responsePrompts[0].promptId);
        setPromptType(companyCheck ? localStorage.getItem('reviewPrompt')?.type ?? responsePrompts[0].type : responsePrompts[0].type);
      }
      if (isSentiment) {
        const local = JSON.parse(localStorage.getItem('sentimentPrompt'))
        const companyCheck = _.find(responsePrompts, a => a.promptId === local?.promptId)
        setPromptName(getPromptSelectName(companyCheck ? JSON.parse(localStorage.getItem('sentimentPrompt')) ?? responsePrompts[0] : responsePrompts[0]))
        setPromptId(companyCheck ? JSON.parse(localStorage.getItem('sentimentPrompt'))?.promptId ?? responsePrompts[0].promptId : responsePrompts[0].promptId);
        setPromptType(companyCheck ? localStorage.getItem('sentimentPrompt')?.type ?? responsePrompts[0].type : responsePrompts[0].type);
      }
      if (isPrompt) {
        const local = JSON.parse(localStorage.getItem('promptPrompt'))
        const companyCheck = _.find(responsePrompts, a => a.promptId === local?.promptId)
        setPromptName(getPromptSelectName(companyCheck ? JSON.parse(localStorage.getItem('promptPrompt')) ?? responsePrompts[0] : responsePrompts[0]))
        setPromptId(companyCheck ? JSON.parse(localStorage.getItem('promptPrompt'))?.promptId ?? responsePrompts[0].promptId : responsePrompts[0].promptId);
        setPromptType(companyCheck ? localStorage.getItem('promptPrompt')?.type ?? responsePrompts[0].type : responsePrompts[0].type);
      }
      if (chatData) {
        const local = JSON.parse(localStorage.getItem('chatPrompt'))
        const companyCheck = _.find(responsePrompts, a => a.promptId === local?.promptId)
        setPromptName(getPromptSelectName(companyCheck ? JSON.parse(localStorage.getItem('chatPrompt')) ?? responsePrompts[0] : responsePrompts[0]))
        setPromptId(companyCheck ? JSON.parse(localStorage.getItem('chatPrompt'))?.promptId ?? responsePrompts[0].promptId : responsePrompts[0].promptId);
        setPromptType(companyCheck ? localStorage.getItem('chatPrompt')?.type ?? responsePrompts[0].type : responsePrompts[0].type);
      }
    } else {
      setPromptName("");
      setPrompt("");
      setJsonResponseSchemaValue("");
    }
  }, [responsePrompts, selectedCompany, localStorage]);

  useEffect(()=>{
    if(runPromptId&&(isReviews|| isSentiment || isPrompt)){
      const foundPrompt = promptsDic?.[runPromptId];
      if(foundPrompt){
        setPromptName(foundPrompt?.name);
        setPromptId(foundPrompt?.promptId);
        setPromptType(foundPrompt?.type);
      }
    }
  },[runPromptId])

  useEffect(()=>{
    if(runPromptId===promptId){
      dispatch(setRunPromptId(null));
    }
  },[promptId, runPromptId])
  

  useEffect(() => {
    if (onPromptChange && promptId) {
      onPromptChange(promptId, promptName, promptType, prompt);
    }
  }, [promptId, promptName, promptType, prompt, onPromptChange]);


  useEffect(() => {
    if (onPromptSettingsChange) {
      onPromptSettingsChange({
        llm,
        temperature,
        seed,
        inputFactor,
        jsonResponse,
        jsonResponseSchema,
        maxLength,
        topP,
        presencePenalty,
        frequencyPenalty,
        jsonResponseSchemaValue,
        responseApi,
      });
    }
  }, [llm, temperature, seed, inputFactor, jsonResponse, jsonResponseSchema, maxLength, topP, presencePenalty, frequencyPenalty, jsonResponseSchemaValue, responseApi, web_search, onPromptSettingsChange]);

  useEffect(() => {
    if (onPromptsInputChange) {
      onPromptsInputChange(promptsInput);
    }
  }, [promptsInput, onPromptsInputChange]);

  useEffect(() => {
    if (promptId) {

      const foundPrompt = _.find(responsePrompts, { promptId: promptId });
      if (foundPrompt) {
        const defaultParametersObj = JSON.parse(foundPrompt.defaultParameters);
        const setOrDefault = (stateSetter, value, defaultValue) => {
          stateSetter(defaultParametersObj?.[value] ?? defaultValue);
        };
        if (isPrompt) {
          setCustomsettings({
            executeParallel:
              foundPrompt.reviewSelectionType === "Multiple" ? true : false,
            singleReview: false,
          });
        }
        setLlm(foundPrompt.llm);
        setReviewSelectionType(foundPrompt.reviewSelectionType);
        setPrompt(foundPrompt.promptText);
        setSystemPrompt(foundPrompt.systemPrompt);
        setJsonResponseSchemaValue(foundPrompt.responseJsonSchema);
        setOrDefault(setVerbosity, "verbosity", "medium");
        setReasoningEffort(normalizeReasoningEffort(foundPrompt.llm, defaultParametersObj?.reasoning_effort ?? getDefailtGpt5xVal(foundPrompt.llm, "medium")));
        setOrDefault(setServiceTier, "serviceTier", null);
        setOrDefault(setTemperature, "temperature");
        setJsonResponseSchema(defaultParametersObj?.['isJsonResponseSchema'])
        // setOrDefault(setJsonResponseSchema, "isJsonResponseSchema");
        setOrDefault(setSeed, 'seed', 'None') ;   
        setOrDefault(setTopP, "topP", 1);
        setOrDefault(setMaxLength, "maxLength");
        setOrDefault(setPresencePenalty, "presencePenalty");
        setOrDefault(setFrequencyPenalty, "frequencyPenalty");
        setOrDefault(setInputFactor, "inputFactor");
        setOrDefault(setJsonResponse, "jsonResponse");
        setOrDefault(setApi, "api", "completions");
        setOrDefault(setNextPromptId, "nextPromptId", null);
        setOrDefault(setCached, "cached", false);
        setOrDefault(setResponseApi, "responseApi", false);
        setOrDefault(setWeb_search, "web_search", false);
        if (isPrompt) {

          setIsMultiple(
            foundPrompt.reviewSelectionType === "Single" ? false : true
          );
          setSelectedReviewIds([]);
          setSelectedReviewText([]);
        }
        if (isSentiment) {
          setIsMultiple(
            foundPrompt.reviewSelectionType === "Single" ? false : true
          );
        }
      }
    }
  }, [promptId, responsePrompts]);
  const phrasesData = useMemo(() => getPhrases(responsePhrases), [responsePhrases])
  useEffect(() => {
    const then = _.chain(selectedThen)
    
      .filter(item => item.selected)
      .map(item => _.trim(`${item.if}\n${item.then}` ?? ''))
      .join('\n')
      .value();
      
    handlePromptInput('RelevantFacts', then)
  }, [selectedThen])


  useEffect(() => {
    let tempK = _.clone(k.promptK);
      
    if (!customSettings?.training) {
      const regex = /(.+?)\n\n%Examples%\n\n/g;
      tempK = tempK.replace(regex, "");
      handlePromptInput('Examples', '')
    }
    if (!customSettings?.brandVoice) {
      const regex = /(.+?)\n\n%Tones%\n\n/g;
      tempK = tempK.replace(regex, "");
      handlePromptInput('Tones', '')
    } else if (customSettings?.brandVoice && selectedBrandVoiceContainer) {
      tempK = tempK.replace(
        /\%Tones\%/g,
        `Mood Type: ${selectedBrandVoiceContainer?.name}\nMood Description:\n${selectedBrandVoiceContainer?.description}`
      );
      handlePromptInput('Tones', `Mood Type: ${selectedBrandVoiceContainer?.name}\nMood Description:\n${selectedBrandVoiceContainer?.description}`)
      tempK = tempK.replace(
        /\%Voice\%/g,
        `${selectedBrandVoiceContainer?.description}`
      );
      handlePromptInput('Voice', `${selectedBrandVoiceContainer?.description}`)
    }


    if (!customSettings?.facts) {
      const regex = /(.+?)\n\n%Facts%\n\n/g;
      tempK = tempK.replace(regex, "");
      handlePromptInput('Facts', '')

    } else if (customSettings?.facts) {
      tempK = tempK.replace(/\%Facts\%/g, factsString);
      handlePromptInput('Facts', factsString)

    }
    if (customSettings?.facts) {

      let factArrayString = JSON.stringify(_.filter(factArr, a => a) ?? [])

      tempK = tempK.replace(/\%FactsArray\%/g, factArrayString);
      handlePromptInput('FactsArray', factArrayString)

    }

    // if (selectedReviewText && tempK.includes("%SelectedReview%")) {
    //   tempK = isSentiment
    //     ? tempK.replace(
    //         /\%SelectedReview\%/g,
    //         `${selectedReviewIds[0]}: ${selectedReviewText}`
    //       )
    //     : tempK.replace(/\%SelectedReview\%/g, selectedReviewText);
    // } else if (selectedReviewText) {
    //   tempK +=
    //     "\n\n" +
    //     (isSentiment
    //       ? `${selectedReviewIds[0]}: ${selectedReviewText}`
    //       : selectedReviewText);
    // }

    // if (selectedReviewText?.length > 0 && tempK.includes("%SelectedReview%")) {
    //   let formattedReviewText = isMultiple
    //     ? selectedReviewIds
    //       .map((id, index) => `${id}: ${selectedReviewText[index]}`)
    //       .join("\n")
    //     : `${selectedReviewIds}: ${selectedReviewText}`;
    //   let temp = tempK
    //   setPromptK(temp.replace(/\%SelectedReview\%/g, ''))

    //   tempK =
    //     isSentiment || isPrompt
    //       ? tempK.replace(/\%SelectedReview\%/g, isSentiment ? "" : formattedReviewText)
    //       : tempK.replace(/\%SelectedReview\%/g, formattedReviewText);

    // }
    if (selectedReviewText?.length > 0 && _.toLower(tempK).includes(_.toLower("%NumberAndTextArray%"))) {
      let formattedReviewText = isMultiple
        ? selectedReviewIds
          .map((id, index) => ({ Number: index + 1, Text: selectedReviewText[index] }))
        : [{ Number: 1, Text: selectedReviewText }];
      // let temp = tempK
      // setPromptK(temp.replace(/\%NumberAndTextArray\%/g, ''))

      // tempK = tempK.replace(/\%NumberAndTextArray\%/g, JSON.stringify(formattedReviewText))
      handlePromptInput('NumberAndTextArray', JSON.stringify(formattedReviewText))
      // isSentiment || isPrompt
      //   ? tempK.replace(/\%ReviewNumberAndTextArray\%/g, isSentiment ? "" : formattedReviewText)
      //   : tempK.replace(/\%ReviewNumberAndTextArray\%/g, formattedReviewText);
    }
    if (selectedReviewIds?.length > 0 && _.toLower(tempK).includes(_.toLower("%Rating%"))) {
      let formattedRating = !isMultiple ? `"${selectedReviewDic[selectedReviewIds[0]]?.rating}"` : '';
      // let temp = tempK
      // setPromptK(temp.replace(/\%NumberAndTextArray\%/g, ''))

      tempK = tempK.replace(/\%Rating\%/g, formattedRating)
      handlePromptInput('Rating', formattedRating)
      // isSentiment || isPrompt
      //   ? tempK.replace(/\%ReviewNumberAndTextArray\%/g, isSentiment ? "" : formattedReviewText)
      //   : tempK.replace(/\%ReviewNumberAndTextArray\%/g, formattedReviewText);
    }

    if (selectedReviewIds?.length > 0 && _.toLower(tempK).includes(_.toLower("%CategorySentimentsArray%"))) {
      let formattedRating = '';
      if (!isMultiple) {
        const topics = _.map(selectedReviewDic[selectedReviewIds[0]]?.topics, it => {
          return { category: topicWithCategory[it.topic], sentiment: it.sentiment }
        })
        const values = _.map(_.groupBy(topics, 'category'), (items, key) => {
          const sentiments = _.uniq(_.map(items, 'sentiment'))
          return `${key}:${sentiments?.length > 1 ? 'Negative' : sentiments[0]}`
        })
        formattedRating = JSON.stringify(values)
      };
      tempK = tempK.replace(/\%CategorySentimentsArray\%/g, formattedRating)
      handlePromptInput('CategorySentimentsArray', formattedRating)
    }
    if (selectedReviewIds?.length > 0 && _.toLower(tempK).includes(_.toLower("%TopicSentimentStrengthArray%"))) {
      let formattedRating = '';
      if (!isMultiple) {
        const topics = _.map(selectedReviewDic[selectedReviewIds[0]]?.topics, it => {
          return { topic: it.topic, sentiment: it.sentiment }
        })
        const values = _.map(_.groupBy(topics, 'topic'), (items, key) => {
          const sentiments = _.uniq(_.map(items, 'sentiment'))
          let keyValue = `${key}:${sentiments?.length > 1 ? 'Negative' : sentiments[0]}`;
          return topicDetails[keyValue]?.strength ? `${keyValue}:${topicDetails[keyValue]?.strength}` : keyValue
        })
        formattedRating = JSON.stringify(values)
      };
      tempK = tempK.replace(/\%TopicSentimentStrengthArray\%/g, formattedRating)
      handlePromptInput('TopicSentimentStrengthArray', formattedRating)
    }
    if (selectedReviewIds?.length > 0 && _.toLower(tempK).includes(_.toLower("%CategoryTopicSentimentStrengthArray%"))) {
      let formattedRating = '';
      if (!isMultiple) {
        const topics = _.map(selectedReviewDic[selectedReviewIds[0]]?.topics, it => {
          return { topic: it.topic, category: topicWithCategory[it.topic], sentiment: it.sentiment }
        })
        const values = _.map(_.groupBy(topics, 'topic'), (items, key) => {
          const sentiments = _.uniq(_.map(items, 'sentiment'))
          const category = items?.[0]?.category
          let topicSentinentValue = `${key}:${sentiments?.length > 1 ? 'Negative' : sentiments[0]}`;
          let keyValue = `${category}:${topicSentinentValue}`;
          return topicDetails[topicSentinentValue]?.strength ? `${keyValue}:${topicDetails[topicSentinentValue]?.strength}` : keyValue
        })
        formattedRating = JSON.stringify(values)
      };
      tempK = tempK.replace(/\%CategoryTopicSentimentStrengthArray\%/g, formattedRating)
      handlePromptInput('CategoryTopicSentimentStrengthArray', formattedRating)
    }
    if (selectedReviewIds?.length > 0 && _.toLower(tempK).includes(_.toLower("%CategoryTopicSentimentStrengthPhrasesArray%"))) {
      let formattedRating = '';
      if (!isMultiple) {
        const topics = _.map(selectedReviewDic[selectedReviewIds[0]]?.topics, it => {
          return { topic: it.topic, category: topicWithCategory[it.topic], sentiment: it.sentiment }
        })
        const values = _.map(_.groupBy(topics, 'topic'), (items, key) => {
          const sentiments = _.uniq(_.map(items, 'sentiment'))
          const category = items?.[0]?.category
          let topicSentinentValue = `${key}:${sentiments?.length > 1 ? 'Negative' : sentiments[0]}`;
          let keyValue = `${category}:${topicSentinentValue}`;
          let phrasesStringValue = topicDetails[topicSentinentValue]?.phrasesString
          const finalPhrases = getPhrasesString(phrasesStringValue)
          const finalData = topicDetails[topicSentinentValue]?.strength && topicDetails[topicSentinentValue]?.phrasesString ? `${keyValue}:${topicDetails[topicSentinentValue]?.strength}:Phrases:${finalPhrases}` : topicDetails[topicSentinentValue]?.strength ? `${keyValue}:${topicDetails[topicSentinentValue]?.strength}` : keyValue

          return finalData
        })
        formattedRating = JSON.stringify(values)
      };
      tempK = tempK.replace(/\%CategoryTopicSentimentStrengthPhrasesArray\%/g, formattedRating)
      handlePromptInput('CategoryTopicSentimentStrengthPhrasesArray', formattedRating)
    }

    let factDevelopment = '';
    if (selectedReviewIds?.length > 0) {
      
      if (isMultiple) {
        const data = _.map(selectedReviewIds, it => ({
          ReviewId: it,
          Review: selectedReviewDic[it]?.reviewText,
          Rating: selectedReviewDic[it]?.rating,
          Response: selectedReviewDic[it]?.responseText
        }))
        factDevelopment = JSON.stringify(data)
      };
      // tempK = tempK.replace(/\%CategoryTopicSentimentStrengthPhrasesArray\%/g, formattedRating)

    }
    handlePromptInput('ReviewsForFactDevelopment', factDevelopment);


    const totalReviews = selectedReviewIds?.length ?? 0;
    const upperBoundPct = Math.floor(totalReviews * 0.2);
    handlePromptInput('TotalReviewsWithText', _.toString(totalReviews));
    handlePromptInput('UpperBoundPct', _.toString(upperBoundPct));

    if (selectedReviewText?.length >= 0 && tempK.includes("%Review%")) {
      let formattedReviewText = isMultiple
        ? selectedReviewIds
          .map((id, index) => `${id}: ${selectedReviewText[index]}`)
          .join("\n")
        : `${selectedReviewText}`;
      // tempK =
      //   isSentiment || isPrompt
      //     ? tempK.replace(/\\%/g, isSentiment ? "" : formattedReviewText)
      //     : tempK.replace(/\%Review\%/g, formattedReviewText);

      // tempK = _.replace(tempK, /\%Review\%/g)
      handlePromptInput('Review', formattedReviewText)
    }

    if (selectedReviewIds?.length === 1) {
     
      const reviewerNameObj = isValidJSON(similarReviews?.agents?.reviewerName) ? JSON.parse(similarReviews?.agents?.reviewerName) : {}
    
      
      handlePromptInput("ReviewId", selectedReviewIds[0]);
      const replacement = {
        "Review": selectedReviewDic[selectedReviewIds[0]]?.reviewText,
        "Response": selectedReviewDic[selectedReviewIds[0]]?.responseText,
        "ReviewerName": selectedReviewDic[selectedReviewIds[0]]?.author,
        "AboutUs": companyData?.description ?? "",
        "Fact": firstSelectedFact?.[0]?.fact ?? "",
        "ReviewerFirstName": reviewerNameObj?.ReviewerName?.['Determined First Name'] ? reviewerNameObj?.ReviewerName?.['Determined First Name'] : "",
        "DeterminedFirstName":  reviewerNameObj?.ReviewerName?.['Determined First Name'] ? reviewerNameObj?.ReviewerName?.['Determined First Name'] : "",
        "Language": (() => {
          const determineAlphabetObj = similarReviews?.agents?.determineAlphabet ? JSON.parse(similarReviews?.agents?.determineAlphabet) : {}
          return determineAlphabetObj?.['DetermineAlphabet'] ? determineAlphabetObj?.['DetermineAlphabet'].Language : ""
        })(),
        "ResponseLanguage": (() => {
          const determineAlphabetObj = similarReviews?.agents?.determineAlphabet ? JSON.parse(similarReviews?.agents?.determineAlphabet) : {}
          return determineAlphabetObj?.['DetermineAlphabet'] ? determineAlphabetObj?.['DetermineAlphabet'].Language : ""
        })(),
      }
      
      Object.entries(replacement).forEach(([key, value]) => {
        if (tempK.includes(`%${key}%` || `{{${_.toLower(key)}}}`)) {
          const newKey = `%${key}%` || `{{${_.toLower(key)}}}`;
          tempK = tempK.replace(new RegExp(newKey, "g"), value);
          handlePromptInput(key, value);

        } else {
          handlePromptInput(key, value);


        }
      })

    }
    // if ((tempK.includes("%PreviousReview%") || tempK.includes("%PreviousRating%")) && selectedReviewIds?.length === 1) {
    const previousReviewObj = similarReviews?.agents?.previousReview ? JSON.parse(similarReviews?.agents?.previousReview) : {}
    const previousReview = previousReviewObj?.ReviewText ? previousReviewObj?.ReviewText : ""
    const previousRating = previousReviewObj?.Rating ? _.toString(previousReviewObj?.Rating) : ""
    tempK = tempK.replace(/\%PreviousReview\%/g, previousReview)
    handlePromptInput('PreviousReview', previousReview)
    tempK = tempK.replace(/\%PreviousRating\%/g, previousRating)
    handlePromptInput('PreviousRating', previousRating)
    // }
    if (tempK.includes("%CompanyName%") && companyData?.name) {
      tempK = tempK.replace(/\%CompanyName\%/g, companyData?.name)
      handlePromptInput('CompanyName', companyData?.name)
    }

    handlePromptInput('ChatData', indexObj)


    if (selectedReviewIds?.length > 0) {
      tempK = tempK.replace(/\%BusinessType\%/g, companyData?.businessType ? companyData?.businessType : 'business')
      handlePromptInput('BusinessType', companyData?.businessType ? companyData?.businessType : 'business')
      const phrasesArr = (selectedReviewDic[selectedReviewIds[0]]?.reviewText ? phrasesData?.withText : phrasesData?.withoutText) ?? []
      _.map(phrasesArr, (it, i) => {
        const myArray = it?.[selectedReviewDic[selectedReviewIds[0]]?.rating] ?? [];
        const randomElement = myArray[Math.floor(Math.random() * myArray.length)];
        const key = (tempK.includes('%Phrase' + (i + 1) + '%') ? 'Phrase' : 'Phase') + (i + 1)
        tempK = tempK.replace(`%${key}%`, JSON.stringify(randomElement))
        handlePromptInput(key, JSON.stringify(randomElement))
      })
    }

    setModifiedK(tempK); setPreviewK(tempK)
  }, [customSettings, k, factsString, selectedReviewText, selectedReviewIds, phrasesData, similarReviews, selectedReviewDic, indexObj, selectededReview]);
  

  const subTopicDic = useMemo(() => convertArrayToDictionary(subTopics, 'topic'), [subTopics])
  const selectedReviews = useMemo(() => {
    const temp = _.map(selectedReviewIds, it => _.find(reviews, a => a.reviewId === it))
    const final = _.map(temp, item => {
      let topics = {};
      topics = item?.topicData?.split(",");
      topics = _.map(topics, (a) => a.split(":"));
      let topicsName =
        _.map(topics, (a) => a[0]).length > 0
          ? _.map(topics, (a) => a[0])
          : null;
      topics =
        topicsName?.length > 0
          ? _.orderBy(
            topics.map((a) => {
              return {
                category: subTopicDic[a[0]]?.category,
                topics: a[0],
                sentiment: a[1],
              };
            }),
            ["topics"],
            ["asc"]
          )
          : null;
      return { ...item, topicsArray: topics?.map(it => `${it.category}:${it.topics}:${it.sentiment}`) ?? [] }
    })
    return final
  }, [selectedReviewIds, reviews, subTopicDic]
  )
  
  useEffect(() => {
    const regex = /\%Examples\%/g;
    const regexArr = /\%ExamplesArray\%/g;
    const regexResponseArr = /\%ExampleResponseArray\%/g;
    const regexWithNAmeArr = /\%ExampleResponseWithReviewerNameArray\%/g;
    const regexWithTopicSentiments = '%ReviewTopicSentimentsArray%'
    let finalK = _.cloneDeep(modifiedK);
    const exampleProperty = promptsInputObj?.Examples
      ? JSON.parse(promptsInputObj?.Examples)
      : "";


    if (promptsInputObj && exampleProperty.trim() !== '""') {
      finalK = finalK.replace(regex, exampleProperty);
      handlePromptInput('Examples', exampleProperty)
      setPreviewK(finalK); setFinalK(finalK);
      // setPromptK(prev=>prev.replace(regex, exampleProperty))
    } else {
      handlePromptInput('Examples', '')
      setPreviewK(finalK); setFinalK(finalK);
    }
    if (promptsInputObj && promptsInputObj?.ExamplesArr.trim()) {
      finalK = finalK.replace(regexArr, promptsInputObj?.ExamplesArr);
      handlePromptInput('ExamplesArray', promptsInputObj.ExamplesArr)
      setPreviewK(finalK); setFinalK(finalK);
      // setPromptK(prev=>prev.replace(regex, exampleProperty))
    } else {
      handlePromptInput('ExamplesArray', '')
      setPreviewK(finalK); setFinalK(finalK);
    }
    if (promptsInputObj && promptsInputObj?.ExampleResponseArr.trim()) {
      finalK = finalK.replace(regexResponseArr, promptsInputObj?.ExampleResponseArr);
      handlePromptInput('ExampleResponseArray', promptsInputObj.ExampleResponseArr)
      setPreviewK(finalK); setFinalK(finalK);
      // setPromptK(prev=>prev.replace(regex, exampleProperty))
    } else {
      handlePromptInput('ExampleResponseArray', '')
      setPreviewK(finalK); setFinalK(finalK);
    }
    if (promptsInputObj && promptsInputObj?.ExampleWithReviwerNameArr.trim() !== '""') {
      finalK = finalK.replace(regexWithNAmeArr, promptsInputObj?.ExampleWithReviwerNameArr);
      handlePromptInput('ExampleResponseWithReviewerNameArray', promptsInputObj?.ExampleWithReviwerNameArr)
      setPreviewK(finalK); setFinalK(finalK);
      // setPromptK(prev=>prev.replace(regex, exampleProperty))
    } else {
      handlePromptInput('ExampleResponseWithReviewerNameArray', '')
      setPreviewK(finalK); setFinalK(finalK);
    }
    if (_.includes(modifiedK, '%ReviewTopicSentimentsArray%')) {
      const mappedArrays = JSON.stringify(_.map(selectedReviews, (it, index) => ({ Number: index + 1, Review: it.reviewText, Sentiments: it.topicsArray ?? [], })))
      finalK = finalK.replace(regexWithTopicSentiments, mappedArrays)
      handlePromptInput('ReviewTopicSentimentsArray', mappedArrays)
      setPreviewK(finalK); setFinalK(finalK);
    }
    else {
      handlePromptInput('ReviewTopicSentimentsArray', '')
      setPreviewK(finalK); setFinalK(finalK);
    }
  }, [promptsInputObj, modifiedK, promptId, selectedReviews, promptPreview]);

  const GetDataTypeKeyword = (prompt) => {
    if (!prompt) return '';
    switch (true) {
      case _.toLower(prompt).includes(_.toLower("%NumberAndTextArray%")):
        return "%NumberAndTextArray%";
      case _.toLower(prompt).includes(_.toLower("%ReviewTopicSentimentsArray%")):
        return "%ReviewTopicSentimentsArray%";
      // case _.toLower(prompt).includes(_.toLower("{{ ChatData }}")):
      //   return "{{ ChatData }}";

    }

    return '';
  };

  const handleGenerateClick = (previewPrompt) => {
    let requestId = uuidv4();
    let isDataType = _.toLower(prompt).includes(_.toLower("%NumberAndTextArray%")) || _.toLower(prompt).includes(_.toLower("%ReviewTopicSentimentsArray%"))
    let dataTypeKeyword = GetDataTypeKeyword(prompt);
    let data = []
    if (isDataType) {
      if (dataTypeKeyword === 'NumberAndTextArray') {
        data = selectedReviewIds?.map((id, index) => (`{ Number: ${index + 1} , Text: ${selectedReviewText[index]} }`))
      }
      else if (dataTypeKeyword === 'ReviewTopicSentimentsArray') {
        // const mappedArrays=_.map(selectedReviews,(it,index)=>({Number:index+1,Review:it.reviewText,Sentiments:it.topicsArray??[],}))
        data = selectedReviews?.map((it, index) => (`{ Number: ${index + 1}, Review: ${it.reviewText}, Sentiments: ${it.topicsArray ?? []} }`))
      }
      else if (dataTypeKeyword === 'ReviewsForFactDevelopment') {
        data = []
      }
    }
    // else {
    //   data = selectedReviewIds?.length > 1 ? selectedReviewIds?.map((it, index) => (it + ':' + selectedReviewText[index])) : []
    // }

    const Input = handlePromptPreview(selectedCompany)
    let inputValues = _.isEmpty(Input) ? { ...promptsInput } : { ...Input, ...promptsInput, AboutUs: companyData?.description ?? '' };
    if (dataTypeKeyword === 'ReviewsForFactDevelopment') {
      inputValues = _.isEmpty(Input) ? { ...promptsInput } : { ...Input, ...promptsInput, AboutUs: companyData?.description ?? '' };
    }
    if (companyData?.donotUseTranslation && dataTypeKeyword !== 'ReviewsForFactDevelopment') {
      inputValues['DonotUseTranslation'] = 'true';
    }
    const reviewIds = selectedReviewIds?.length > 0 ? selectedReviewIds[0] : null;
  
    let PromptInput = {
      prompt: {
        // Prompt: previewK,
        Prompt: previewPrompt ? finalK : isSentiment? (k.systemPromptK + promptK)  :promptK,
        SystemPrompt: systemPrompt,
        CachingKey: promptsDic?.[promptId]?.cachingKey  ? (promptsDic?.[promptId]?.cachingKey + ':pg') : null,
        temperature: (temperature === null || !isTemperatureChecked) ? null : parseFloat(temperature),
        maxLength: parseInt(maxLength),
        topP: (topP===null || !isTopPChecked)?null: parseFloat(topP),
        isContainsMaxInput: false,
        llm: llm,
        seed: seed,
        presencePenalty: parseFloat(presencePenalty),
        jsonResponse: jsonResponse ? jsonResponse : false,
        frequencyPenalty: parseFloat(frequencyPenalty),
        companyId: selectedCompany ? selectedCompany : defaultGuid,
        isJsonResponseSchema: jsonResponseSchema,
        responseJsonSchema: jsonResponseSchemaValue,
        verbosity: _.toLower(verbosity),
        reasoningEffort: _.toLower(normalizeReasoningEffort(llm, reasoning_effort)),
        serviceTier: serviceTier || null,
        api: api,
        nextPromptId: nextPromptId,
      },
      // responseApi: responseApi,
      Parallel: isPrompt || isSentiment ? customSettings?.executeParallel : false,
      // Reviews:[],
      Data: previewPrompt ? [] : data,
      DataType: { Name: dataTypeKeyword, IsObjectArray: isDataType },
      ProcessSingleReview: isPrompt || isSentiment ? customSettings?.singleReview : true,
      Input: inputValues,
    };
    let ExtraData = {
      PromptId: promptId,
      ReviewId: reviewIds,
      PromptName: promptsDic?.[promptId]?.name,
      PromptType: promptsDic?.[promptId]?.type,
      PromptSubType: promptsDic?.[promptId]?.subType,
      RequestId: requestId,
      apiKey: apiKey,
      id: chatData ? chatId : null,
    };
    setSelectedId(reviewIds);
    
    dispatch(
      triggerExecutePromptMultiple({ PromptInput, ExtraData }, selectedCompany, promptId)
    );
    setResponseApi(false);
    setRequestId(requestId)
    setRefresh(!refresh);
  };

  useEffect(() => {
    if (promptOutPut?.length > 0 && selectedId) { 
      if (isReviews && tabValue === 0) {
        setCache({
          ...cache,
          [selectedId]: promptOutPut,
        });
      }
      if (isSentiment) {
        setSentimentCache({
          ...sentimentCache,
          [selectedId]: promptOutPut,
        });
      }
      if (isReviews && tabValue === 1) {
        setVanillaCache({
          ...vanillaCache,
          [selectedId]: promptOutPut,
        });
      }
      if (isPrompt) {
        setPromptOutput(promptOutPut);
      }
      if (chatData) {
        setPromptOutput(promptOutPut);
        setText(promptOutPut);

      }
    }
  }, [promptOutPut, selectedId]); 
  const handleSliderMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSliderMenuClose = () => {
    setAnchorEl(null);
  };

  const openSliderMenu = Boolean(anchorEl);

  const handleResponseTabChange = (event, newValue) => {
    setTabValue(parseInt(newValue));
  };
  const handleReponseGenerateButton = (previewPrompt) => {
    if (tabValue === 0 && !isSentiment) {
      handleGenerateClick();
    } else if (tabValue === 1 && !isSentiment) {
      // dispatch(fetchGenerateResponse({ ReviewId: selectedReviewIds[0] }));
      handleGenerateClick();
      setSelectedId(selectedReviewIds[0]);
    } else if (isSentiment) {
      handleGenerateClick(previewPrompt);
    } else if (isPrompt) {
      handleGenerateClick();
    }
    setRefresh(!refresh);
  };

  
    // useEffect(()=>{
    //   if(llm==="gpt-5.1" || llm==="gpt-5.2"){
    //      setReasoningEffort('none')
    //   }else if (llm==="gpt-5-nano"){
    //     setReasoningEffort('minimal')
    //   }
    //   else{
    //     setReasoningEffort('medium')
    //   }
    // },[llm])
  return (
    <CustomPrompt
      boxHeight={boxHeight}
      selectedTab={selectedTab}
      handleTabChange={handleTabChange}
      openDrawer={openDrawer}
      toggleDrawer={toggleDrawer}
      gptUsage={gptUsage}
      selectedReviewText={selectedReviewText}
      promptName={promptName}
      promptId={promptId}
      setPromptName={setPromptName}
      responsePrompts={responsePrompts}
      setPromptId={setPromptId}
      setPromptType={setPromptType}
      handleOpenWarning={handleOpenWarning}
      handleOpen={handleOpen}
      openSliderMenu={openSliderMenu}
      handleSliderMenuClose={handleSliderMenuClose}
      anchorEl={anchorEl}
      llm={llm}
      setLlm={setLlm}
      cached={cached} setCached={setCached}
      web_search={web_search} setWeb_search={setWeb_search}
      presencePenalty={presencePenalty}
      selectedLengthValue={selectedLengthValue}
      setSelectedToneValue={setSelectedToneValue}
      setPresencePenalty={setPresencePenalty}
      temperature={temperature}
      seed={seed}
      setSeed={setSeed}
      verbosity={verbosity}
      reasoning_effort={reasoning_effort}
      setVerbosity={setVerbosity}
      setReasoningEffort={setReasoningEffort}
      setTemperature={setTemperature}
      frequencyPenalty={frequencyPenalty}
      setFrequencyPenalty={setFrequencyPenalty}
      maxLength={maxLength}
      setMaxLength={setMaxLength}
      topP={topP}
      setTopP={setTopP}
      inputFactor={inputFactor}
      setInputFactor={setInputFactor}
      jsonResponse={jsonResponse}
      setJsonResponse={setJsonResponse}
      jsonResponseSchema={jsonResponseSchema}
      setJsonResponseSchema={setJsonResponseSchema}
      customSettings={customSettings}
      setCustomsettings={setCustomsettings}
      setPrompt={setPrompt}
      systemPrompt={systemPrompt} setSystemPrompt={setSystemPrompt}
      handleSliderMenuOpen={handleSliderMenuOpen}
      selectedToneValue={selectedToneValue}
      setSelectedLengthValue={setSelectedLengthValue}
      previewK={previewK}
      setPreviewK={setPreviewK}
      systemPromptPreviewK={systemPromptPreviewK}
      setSystemPromptPreviewK={setSystemPromptPreviewK}
      isHovered={isHovered}
      handleCopyClick={handleCopyClick}
      setIsHovered={setIsHovered}
      handleReponseGenerateButton={handleReponseGenerateButton}
      executePromptMultiple={promptOutPut}
      isSentiment={isSentiment}
      isReviews={isReviews}
      tabValue={tabValue}
      handleResponseTabChange={handleResponseTabChange}
      tokens={tokens}
      vanillaCache={vanillaCache}
      sentimentCache={sentimentCache}
      text={text}
      setText={setText}
      setIsHovered2={setIsHovered2}
      cache={cache}
      isHovered2={isHovered2}
      handleOutputCopyClick={handleOutputCopyClick}
      selectedReviewIds={selectedReviewIds}
      handleClose={handleClose}
      selectedCompany={selectedCompany}
      openWarning={openWarning}
      handleDelete={handleDelete}
      handleCloseWarning={handleCloseWarning}
      open={open}
      prompt={prompt}
      requestId={requestId}
      isPrompt={isPrompt && !isSentiment}
      buttonText={buttonText}
      reviewSelectionType={reviewSelectionType}
      formattedData={formattedData}
      companyTopics={topicData}
      handleStyleClick={handleStyleClick}
      selectedStyle={selectedStyle}
      promptTemplates={checkforNullDescription ? _.filter(_.cloneDeep(promptTemplateData), it => it.value !== 'Context Topics' && it.value !== 'Category And Topics With Description Array') : promptTemplateData}
      setTopicType={setTopicType}
      topicType={topicType}
      setFinalK={setFinalK}
      promptsInput={promptsInput}
      chatData={chatData}
      responseApi={responseApi}
      setResponseApi={setResponseApi}
      api={api}
      setApi={setApi}
      nextPromptId={nextPromptId}
      setNextPromptId={setNextPromptId}
      isTopPChecked={isTopPChecked} setIsTopPChecked={setIsTopPChecked}
    isTemperatureChecked={isTemperatureChecked} setIsTemperatureChecked={setIsTemperatureChecked}
    selectedThen={selectedThen} setSelectedThen={setSelectedThen}
    setPromptTab={setPromptTab}
    />
  );
};

export default CustomizeResponse;
